import { api } from "./_client";

export async function listProjects() {
    const { data } = await api.get("/projects");
    return data;
}

// iter-108: active estimate/analyze jobs for the user, grouped by
// project_id. Used by ProjectsPage to render a progress bar on cards
// whose quote is still cooking (e.g. fresh email-scan auto-quote).
export async function listActiveProjectJobs() {
    const { data } = await api.get("/projects/active-jobs");
    return data?.jobs || [];
}

export async function createProject(payload) {
    const { data } = await api.post("/projects", payload);
    return data;
}

export async function deleteProject(id) {
    const { data } = await api.delete(`/projects/${id}`);
    return data;
}

export async function updateProject(id, payload) {
    const { data } = await api.patch(`/projects/${id}`, payload);
    return data;
}

// -------- Per-project file folder (iter-86) --------

export async function getProject(id) {
    const { data } = await api.get(`/projects/${id}`);
    return data;
}

export async function resetProject(projectId) {
    const { data } = await api.post(`/projects/${projectId}/reset`);
    return data;
}

// Legacy helper, kept for any callers still wiring to the Swift-only path.

export async function getProjectPlugins(projectId) {
    const { data } = await api.get(`/projects/${projectId}/plugins`);
    return data.active_ids || [];
}
